import type { IRequestOptions, IValidatedResponse } from '../../httpClient';
import { postRequest } from '../../httpClient';
import type { IRebuildClipsRequest } from './rebuild-clips-request';
import type { IRebuildClipsResponse } from './rebuild-clips-response';
import { rebuildClipsResponseSchema } from './rebuild-clips-response';

export async function rebuildClipsApi(
  body?: IRebuildClipsRequest,
  options?: IRequestOptions,
): Promise<IValidatedResponse<IRebuildClipsResponse>> {
  return postRequest<IRebuildClipsResponse>({
    path: '/sys/pipeline/rebuild-clips/v1',
    body: body ?? {},
    schema: rebuildClipsResponseSchema,
    options,
  });
}
